module.exports = __webpack_public_path__ + "img/reachmd_plugin.de354a38.png";